<template>
  <router-view></router-view>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',

  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },

  created () {
    this.checkCurrentLogin();
  },

  updated () {
    this.checkCurrentLogin();
  },

  methods: {
    checkCurrentLogin () {
      //if (!this.currentUser && this.$route.path !== '/start') {
      //  this.$router.push('/?redirect=' + this.$route.path);
      //}
      if (this.$route.path === '/questions') {
        if (!this.currentUser) {
          this.$router.push('/');
        }
      }
    }
  },
}
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #8c67ef;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

//
$grey-darker: #2a2a26;
$grey-dark: #3e3f3a;
$grey: #8e8c84;
$grey-light: #c9c8b8;
$grey-lighter: #e6e1d7;

$white-ter: #f8f5f0;

$orange: #f47c3c;
$green: #93c54b;
$blue: #29abe0;
$red: #d9534f;

$primary: #325d88 !default;
$warning: $orange;
$warning-invert: #fff;

$family-sans-serif: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif;
$body-size: 14px;

$link: #8E8C84;

$pagination-background-color: $grey-lighter;

$navbar-background-color: $grey-dark;
$navbar-item-color: $grey-light;
$navbar-item-hover-color: $white-ter;
$navbar-item-active-color: $white-ter;
$navbar-item-hover-background-color: $grey-darker;
$navbar-dropdown-arrow: $navbar-item-color;

// Make containers narrower because we put images directly into cards
$gap: 32px;
$tablet: 769px;
$desktop: 768px + (2 * $gap);
$widescreen: 768px + (2 * $gap);
$fullhd: 768px + (2 * $gap);

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

// Overrides
@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);

.button,
.control.has-icons-left .icon,
.control.has-icons-right .icon,
.input,
.pagination-ellipsis,
.pagination-link,
.pagination-next,
.pagination-previous,
.select,
.select select,
.textarea {
  height: 2.572em;
}

.button {
  text-transform: uppercase;
}

.notification {
  @each $name, $pair in $colors {
    $color: nth($pair, 1);
    $color-invert: nth($pair, 2);

    &.is-#{$name} {
      a:not(.button) {
        color: $color-invert;
        text-decoration: underline;
      }
    }
  }
}

.card {
  box-shadow: 0 2px 3px rgba($grey-dark, 0.1), 0 0 0 1px rgba($grey-dark, 0.1);
}

.navbar {
  border-radius: $radius;

  .navbar-item,
  .navbar-link {
    font-size: 0.875rem;
    font-weight: 700;
    text-transform: uppercase;

    &.is-active {
      background-color: darken($grey-dark, 5);

      @include touch {
        background-color: rgba($grey-dark, 0.25);
      }
    }
  }

  @include desktop {
    .navbar-dropdown .navbar-item {
      color: $text;
    }
  }

  @include touch {
    .navbar-menu {
      background-color: inherit;
    }
  }

  &:not([class*='is-']) .navbar-burger span {
    background-color: $white-ter;
  }

  @each $name, $pair in $colors {
    $color: nth($pair, 1);
    $color-invert: nth($pair, 2);

    &.is-#{$name} {
      @include touch {
        .navbar-item,
        .navbar-link {
          color: rgba($color-invert, 0.7);
          &.is-active {
            color: $color-invert;
          }
        }
      }
    }
  }

  &.is-transparent {
    background-color: transparent;
  }
}

.hero {
  // Colors
  .navbar {
    background-color: $grey-dark;
  }
  @each $name, $pair in $colors {
    $color: nth($pair, 1);
    $color-invert: nth($pair, 2);

    &.is-#{$name} {
      .navbar {
        background: none;
      }
    }
  }
}

.pagination-link,
.pagination-next,
.pagination-previous {
  color: $primary;
  background-color: $pagination-background-color;
}
</style>



// WEBPACK FOOTER //
// src/App.vue